"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupLocales = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var formatters_1 = require("@webnuts/formatters");
var format_number_1 = require("@webnuts/formatters/build/number/internal/format-number");
var fallbackLocalesGroup = new Proxy({}, {
    get: function (target, property, receiver) {
        return '';
    }
});
var fallbackLocales = new Proxy({}, {
    get: function (target, property, receiver) {
        return fallbackLocalesGroup;
    }
});
function setupLocales(_a) {
    var locales = _a.locales, initial = _a.initial, source = _a.source;
    var LocaleContext = react_1.createContext({
        state: { state: 'loading', locale: initial },
        dispatch: function () {
            throw new Error('Missing <LocaleProvider> in your tree');
        },
        result: new Proxy({}, {
            get: function () {
                throw new Error('Missing <LocaleProvider> in your tree');
            }
        })
    });
    LocaleContext.displayName = 'LocaleContext';
    var LocaleProvider = function (_a) {
        var children = _a.children;
        var _b = __read(react_1.useReducer(function (state, action) {
            switch (action.type) {
                case 'SET_DONE':
                    return __assign(__assign({}, state), { state: 'done', locales: action.data });
                case 'SET_ERROR':
                    return __assign(__assign({}, state), { state: 'error', error: action.error });
                case 'SET_TRANSLATE':
                    return __assign(__assign({}, state), { locale: __assign(__assign({}, state.locale), { locale: action.translate }) });
                case 'SET_FORMAT':
                    return __assign(__assign({}, state), { locale: __assign(__assign({}, state.locale), { format: action.format }) });
                case 'SET_TIMEZONE':
                    return __assign(__assign({}, state), { locale: __assign(__assign({}, state.locale), { timeZone: action.timeZone }) });
                default:
                    return state;
            }
        }, __assign({ locale: __assign({}, initial) }, (source instanceof Promise ? { state: 'loading' } : { state: 'done', locales: source }))), 2), state = _b[0], dispatch = _b[1];
        var _c = __read(state.locale.locale.split('-'), 1), maybeLocaleLanguage = _c[0];
        var fallbackLocale = locales.includes(maybeLocaleLanguage) ? maybeLocaleLanguage : undefined;
        /** All the translations for the current locale. */
        var currentLocales = react_1.useMemo(function () {
            return state.state === 'done'
                ? Object.entries(state.locales).reduce(function (groups, _a) {
                    var _b;
                    var _c = __read(_a, 2), groupKey = _c[0], groupValue = _c[1];
                    return __assign(__assign({}, groups), (_b = {}, _b[groupKey] = Object.entries(groupValue).reduce(function (group, _a) {
                        var _b, _c, _d, _e;
                        var _f;
                        var _g = __read(_a, 2), key = _g[0], localesValue = _g[1];
                        var localePath = groupKey + "." + key + "." + state.locale;
                        var defaultValue = "@" + localePath;
                        if (localesValue === undefined) {
                            return __assign(__assign({}, group), (_b = {}, _b[key] = defaultValue, _b));
                        }
                        var localeValue = (_f = localesValue[state.locale.locale]) !== null && _f !== void 0 ? _f : (fallbackLocale === undefined ? undefined : localesValue[fallbackLocale]);
                        if (localeValue !== undefined) {
                            return __assign(__assign({}, group), (_c = {}, _c[key] = localeValue, _c));
                        }
                        if (process.env.NODE_ENV === 'development') {
                            // During development fail loudly when hitting missing locales.
                            return __assign(__assign({}, group), (_d = {}, Object.defineProperty(_d, key, {
                                get: function () {
                                    throw new Error("Missing locale string for path: " + localePath);
                                },
                                enumerable: false,
                                configurable: true
                            }), _d));
                        }
                        else {
                            // In production and test, keep silent and use some sort of fallback.
                            return __assign(__assign({}, group), (_e = {}, Object.defineProperty(_e, key, {
                                get: function () {
                                    console.warn("Missing locale string for path: " + localePath);
                                    return defaultValue;
                                },
                                enumerable: false,
                                configurable: true
                            }), _e));
                        }
                    }, {}), _b));
                }, {})
                : fallbackLocales;
        }, [state, fallbackLocale]);
        var setTranslate = react_1.useCallback(function (translate) { return dispatch({ type: 'SET_TRANSLATE', translate: translate }); }, [dispatch]);
        var setFormat = react_1.useCallback(function (format) { return dispatch({ type: 'SET_FORMAT', format: format }); }, [dispatch]);
        var setTimeZone = react_1.useCallback(function (timeZone) { return dispatch({ type: 'SET_TIMEZONE', timeZone: timeZone }); }, [dispatch]);
        var innerFormatDate = react_1.useCallback(function (value, options) {
            return formatters_1.formatDate(value, __assign({ locale: state.locale.format, timeZone: state.locale.timeZone }, options));
        }, [state.locale]);
        var innerFormatTime = react_1.useCallback(function (value, options) {
            return formatters_1.formatTime(value, __assign({ locale: state.locale.format, timeZone: state.locale.timeZone }, options));
        }, [state.locale]);
        var innerFormatDateTime = react_1.useCallback(function (value, options) {
            return formatters_1.formatDateTime(value, __assign({ locale: state.locale.format, timeZone: state.locale.timeZone }, options));
        }, [state.locale]);
        var innerFormatCurrency = react_1.useCallback(function (value, currency, options) { return formatters_1.formatCurrency(value, currency, __assign({ locale: state.locale.format }, options)); }, [state.locale]);
        var innerFormatDecimal = react_1.useCallback(function (value, options) { return formatters_1.formatDecimal(value, __assign({ locale: state.locale.format }, options)); }, [state.locale]);
        var innerFormatNumber = react_1.useCallback(function (value, options) { return format_number_1.formatNumber(value, __assign({ locale: state.locale.format }, options)); }, [state.locale]);
        var result = react_1.useMemo(function () { return ({
            state: state.locale,
            setTranslate: setTranslate,
            setFormat: setFormat,
            setTimeZone: setTimeZone,
            locales: currentLocales,
            _state: state,
            formatDate: innerFormatDate,
            formatTime: innerFormatTime,
            formatDateTime: innerFormatDateTime,
            formatCurrency: innerFormatCurrency,
            formatDecimal: innerFormatDecimal,
            formatNumber: innerFormatNumber
        }); }, [
            currentLocales,
            innerFormatCurrency,
            innerFormatDate,
            innerFormatDateTime,
            innerFormatDecimal,
            innerFormatNumber,
            innerFormatTime,
            setFormat,
            setTimeZone,
            setTranslate,
            state
        ]);
        var value = react_1.useMemo(function () { return ({ state: state, dispatch: dispatch, result: result }); }, [state, dispatch, result]);
        // After the first render, await resolving the locales promise and set the
        // state based on it.
        react_1.useEffect(function () {
            if (state.state !== 'loading') {
                return;
            }
            Promise.resolve(source)
                .then(function (data) { return dispatch({ type: 'SET_DONE', data: data }); })
                .catch(function (error) { return dispatch({ type: 'SET_ERROR', error: error }); });
        }, [dispatch, state]);
        // Render the memoized state + dispatcher for anyone to consume.
        return jsx_runtime_1.jsx(LocaleContext.Provider, __assign({ value: value }, { children: children }), void 0);
    };
    LocaleProvider.displayName = 'LocaleProvider';
    /**
     * Consumes the currently available locale context, returning
     *
     * - A function for translating string.
     * - A context provider, that you should inject high up the component tree.
     */
    var useLocale = function () {
        var result = react_1.useContext(LocaleContext).result;
        return result;
    };
    return { useLocale: useLocale, LocaleProvider: LocaleProvider };
}
exports.setupLocales = setupLocales;
